module.exports = __webpack_public_path__ + "assets/img/news.58d4a5c4.jpg";